import { cn } from "@/lib/utils";

export function Spinner({ className, size = "md" }) {
  const sizeClasses = {
    sm: "h-4 w-4 border-2",
    md: "h-8 w-8 border-3",
    lg: "h-12 w-12 border-4"
  };

  return (
    <div
      className={cn(
        "animate-spin rounded-full border-blue-800 border-t-transparent",
        sizeClasses[size],
        className
      )}
    />
  );
}

export function LoadingScreen({ message = "Loading..." }) {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-slate-50">
      <Spinner size="lg" />
      <p className="mt-4 text-slate-600 font-medium">{message}</p>
    </div>
  );
}
